import type { MagentoGetProductPrice } from "@jti/magento-types";
import { useQuery } from "@jti/rest-api";

import { magento } from "../../clients/getClient";

export const useProductPrice = (sku: string | undefined = "", quantity: number | undefined = 0) =>
  useQuery<MagentoGetProductPrice>(
    ["USE_GET_PRODUCT_PRICE", sku, quantity],
    () => magento.getProductPrice(sku, quantity),
    {
      enabled: !!sku && !!quantity,
    }
  );
